import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}


export const NotificationApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        length?: number;
        start?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.getNotifications}?start=${start}&length=${length}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getNotificationById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getByIdNotification}${id}/`,
        method: "GET",
      }),
    }),
    addNotifications: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addNotification,
        method: "POST",
        body,
      }),
    }),
    updateNotifications: builder.mutation<CommonResponseType, { body: any; id: number }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateNotification}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deleteNotifications: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteNotification}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
useAddNotificationsMutation,
useUpdateNotificationsMutation,
useLazyGetNotificationByIdQuery,
useLazyGetNotificationsQuery,
useDeleteNotificationsMutation
} = NotificationApi;
